import * as React from "react"
import Navbar from "../components/navbar/navbar"
import Footer from "./footer"
import "./layout.css"

// Page titles, meta tags and JSON-LD are set per page via Gatsby's Head API
// (see components/seo.js), so they are present in the server-rendered HTML.
const Layout = ({ children }) => {
  return (
    <div className="flex flex-col min-h-screen bg-black overflow-x-hidden font-sans">
      <Navbar />
      <main className="flex-grow overflow-hidden">{children}</main>
      <Footer />
    </div>
  )
}

export default Layout
